<script setup lang="ts">
import { computed, ref } from 'vue';

import { mdiFileDocumentOutline, mdiDownload } from '@mdi/js';
import { chevronLeft } from '@/components/icons/icons';
import { downloadUrl } from '@/utils/download';
import { useSystemStore } from '@/stores/systemStore';

const showInstructionsManuals = ref(false);

function openInstructionManualMenu(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();
  showInstructionsManuals.value = !showInstructionsManuals.value;
}

const languageOptions = computed(() => {
  return useSystemStore().languages?.map((item) => {
    return {
      title: item.displayName,
      value: item.name,
    };
  });
});

function downloadHandbook(langName: string) {
  const absoluteUrl = new URL(`/downloads/ifu-${langName}.pdf`, window.location.origin).toString();

  downloadUrl(absoluteUrl);
}
</script>

<template>
  <div
    class="d-flex cursor-pointer"
    :class="showInstructionsManuals ? 'menuOpen' : ''"
    @click="openInstructionManualMenu"
  >
    <v-icon :icon="mdiFileDocumentOutline" class="mr-3" />

    {{ $t('InstructionManualLabel') }}
    <v-icon
      class="ml-1"
      :icon="chevronLeft"
      :class="showInstructionsManuals ? 'rotate-90' : 'rotate-minus-90'"
    />
  </div>

  <ul v-if="showInstructionsManuals">
    <li
      v-for="languageOption in languageOptions"
      :key="languageOption.value"
      class="ma-4 cursor-pointer ml-7"
      @click="downloadHandbook(languageOption.value)"
    >
      <v-icon class="mr-1" :icon="mdiDownload" />{{ languageOption.title }}
    </li>
  </ul>
</template>

<style lang="scss" scoped>
ul {
  list-style: none;
}
.menuOpen {
  margin-top: 9.5px;
}
.rotate-90 {
  transform: rotate(90deg);
}
.rotate-minus-90 {
  transform: rotate(-90deg);
}
</style>
